import React, { Component } from 'react'
import { Consumer } from './context'

export default importion => {
  return class AsyncComponent extends Component {
    state = {
      component: null,
      provider: {}
    }

    componentDidMount() {
      importion().then(res => {
        this.setState({ component: res.default })
      })
    }

    render() {
      const Component = this.state.component
      if (!Component) return null
      return (
        <div className="trans">
          <Consumer>
            {value => <Component {...this.props} context={value} />}
          </Consumer>
        </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/asyncComponent.js